/**
 * @generated SignedSource<<2cb129a4867a85593cb5d88d390ad45e>>
 * @relayHash 0504b7065083b98aa42b40ffe5be0efa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 654b627817353273a312709c32bb47617276efafdc9a468b0def507bcd7e0cae

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type GoalPanelQuery$variables = {
  appSettingsContainerId?: string | null;
  ari: string;
  capabilitiesContainerId: string;
  includeDraftUpdate: boolean;
  includeWorkspaceTimezone?: boolean | null;
  queryContext?: string | null;
};
export type GoalPanelQuery$data = {
  readonly goals_appSettings?: {
    readonly appTimezone: string | null;
  } | null;
  readonly goals_byId: Result<{
    readonly id: string;
    readonly key: string;
    readonly latestDraftUpdate?: {
      readonly " $fragmentSpreads": FragmentRefs<"GoalDraftUpdateAdapter_draft">;
    } | null;
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalCustomFields" | "GoalFocusAreas" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatusField" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "GoalUpdateComposerCreate" | "ParentGoal" | "SubGoals">;
  } | null, unknown>;
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoalPanelTabs">;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "appSettingsContainerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "capabilitiesContainerId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDraftUpdate"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeWorkspaceTimezone"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v6 = {
  "condition": "includeWorkspaceTimezone",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "containerId",
          "variableName": "appSettingsContainerId"
        }
      ],
      "concreteType": "TownsquareGoalsAppSettings",
      "kind": "LinkedField",
      "name": "goals_appSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appTimezone"
        }
      ]
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "ari"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "url"
},
v13 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v17 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v18 = {
  "kind": "ScalarField",
  "name": "canManagePeriodicMetricTargets"
},
v19 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedGoals"
},
v20 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v21 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v22 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v23 = [
  (v11/*: any*/),
  (v7/*: any*/)
],
v24 = [
  (v7/*: any*/)
],
v25 = {
  "kind": "InlineFragment",
  "selections": (v24/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v26 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v27 = {
  "concreteType": "TownsquareGoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "value"
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v31 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v29/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v30/*: any*/)
  ]
},
v32 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "kind"
},
v34 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v29/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v30/*: any*/)
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "score"
},
v36 = [
  (v28/*: any*/),
  (v35/*: any*/)
],
v37 = [
  (v28/*: any*/),
  (v35/*: any*/),
  {
    "concreteType": "TownsquareCompletionGoalState",
    "kind": "LinkedField",
    "name": "atCompletionState",
    "plural": false,
    "selections": (v36/*: any*/)
  }
],
v38 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v39 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v40 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v41 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v40/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v43 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v44 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v45 = {
  "kind": "ScalarField",
  "name": "end"
},
v46 = {
  "kind": "ScalarField",
  "name": "start"
},
v47 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v46/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v49 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v45/*: any*/)
  ]
},
v50 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v48/*: any*/),
    (v49/*: any*/)
  ]
},
v51 = [
  (v28/*: any*/),
  (v7/*: any*/)
],
v52 = {
  "kind": "ScalarField",
  "name": "variance"
},
v53 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v51/*: any*/)
    },
    (v52/*: any*/)
  ]
},
v54 = {
  "kind": "ScalarField",
  "name": "type"
},
v55 = {
  "kind": "ScalarField",
  "name": "subType"
},
v56 = {
  "kind": "ScalarField",
  "name": "archived"
},
v57 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v58 = {
  "kind": "ScalarField",
  "name": "source"
},
v59 = {
  "kind": "ScalarField",
  "name": "time"
},
v60 = [
  (v59/*: any*/),
  (v7/*: any*/),
  (v28/*: any*/)
],
v61 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v62 = [
  (v61/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_DESC"
    ]
  }
],
v63 = [
  (v15/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/)
],
v64 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v65 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v66 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v67 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v65/*: any*/),
    (v66/*: any*/)
  ]
},
v68 = {
  "args": (v62/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v28/*: any*/),
            (v59/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v63/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "TownsquareGoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v44/*: any*/),
                        {
                          "concreteType": "TownsquareGoal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": (v24/*: any*/)
                        },
                        {
                          "concreteType": "TownsquareGoalState",
                          "kind": "LinkedField",
                          "name": "newState",
                          "plural": false,
                          "selections": (v36/*: any*/)
                        },
                        (v7/*: any*/)
                      ]
                    }
                  ],
                  "type": "TownsquareFromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v44/*: any*/)
                  ],
                  "type": "TownsquareFromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "TownsquareFromMetricUpdate"
                }
              ]
            },
            (v26/*: any*/),
            (v15/*: any*/)
          ]
        },
        (v64/*: any*/)
      ]
    },
    (v67/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
},
v69 = {
  "args": (v62/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v70 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v51/*: any*/)
},
v71 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v72 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v73 = [
  (v59/*: any*/),
  (v7/*: any*/)
],
v74 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v45/*: any*/)
  ]
},
v75 = {
  "args": (v62/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v73/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                (v74/*: any*/)
              ]
            },
            (v28/*: any*/)
          ]
        },
        (v52/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_DESC\"])"
},
v76 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v77 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v76/*: any*/),
    (v54/*: any*/)
  ]
},
v78 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v73/*: any*/)
},
v79 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v8/*: any*/),
                (v54/*: any*/),
                (v55/*: any*/),
                (v56/*: any*/),
                (v57/*: any*/),
                (v58/*: any*/),
                (v78/*: any*/)
              ]
            },
            (v70/*: any*/),
            (v71/*: any*/),
            (v72/*: any*/)
          ]
        }
      ]
    }
  ]
},
v80 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v36/*: any*/)
},
v81 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v82 = [
  (v81/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v83 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v84 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v29/*: any*/)
},
v85 = [
  (v49/*: any*/)
],
v86 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v85/*: any*/)
},
v87 = [
  (v15/*: any*/),
  (v7/*: any*/)
],
v88 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v87/*: any*/)
  }
],
v89 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v87/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": (v88/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v90 = {
  "args": (v82/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
},
v91 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v92 = [
  (v54/*: any*/),
  (v76/*: any*/)
],
v93 = [
  (v31/*: any*/),
  (v34/*: any*/),
  (v7/*: any*/)
],
v94 = {
  "concreteType": "TownsquareGoalAppCapabilities",
  "kind": "LinkedField",
  "name": "apps",
  "plural": false,
  "selections": [
    (v18/*: any*/)
  ]
},
v95 = {
  "kind": "ScalarField",
  "name": "description"
},
v96 = {
  "kind": "ScalarField",
  "name": "count"
},
v97 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v95/*: any*/)
],
v98 = [
  (v61/*: any*/)
],
v99 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v100 = [
  {
    "concreteType": "TownsquareConnectedUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "sourceGoal",
        "plural": false,
        "selections": (v24/*: any*/)
      }
    ]
  }
],
v101 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v102 = {
  "kind": "ScalarField",
  "name": "summary"
},
v103 = [
  (v15/*: any*/),
  (v9/*: any*/),
  (v8/*: any*/),
  (v40/*: any*/),
  (v7/*: any*/)
],
v104 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v103/*: any*/)
},
v105 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v103/*: any*/)
},
v106 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v107 = [
  (v28/*: any*/),
  (v59/*: any*/),
  (v7/*: any*/)
],
v108 = {
  "concreteType": "TownsquareUpdateGenerationSettings",
  "kind": "LinkedField",
  "name": "updateGenerationSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "templateKey"
    }
  ]
},
v109 = [
  (v96/*: any*/)
],
v110 = [
  (v15/*: any*/),
  (v40/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/)
],
v111 = [
  {
    "kind": "ScalarField",
    "name": "label"
  },
  (v49/*: any*/)
],
v112 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v113 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v8/*: any*/),
                (v7/*: any*/),
                (v40/*: any*/),
                (v9/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v112/*: any*/),
            (v44/*: any*/)
          ]
        }
      ]
    },
    (v26/*: any*/)
  ]
},
v114 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v102/*: any*/),
      (v95/*: any*/),
      (v104/*: any*/),
      (v105/*: any*/),
      (v44/*: any*/),
      (v106/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v115 = [
  (v81/*: any*/),
  (v13/*: any*/)
],
v116 = [
  {
    "concreteType": "TownsquareHighlightEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v88/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      (v6/*: any*/),
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "CatchField",
        "field": {
          "args": (v10/*: any*/),
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goals_byId",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            {
              "args": (v14/*: any*/),
              "kind": "FragmentSpread",
              "name": "GoalFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalPanelTitleField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalType"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalMetrics"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ParentGoal"
            },
            {
              "kind": "FragmentSpread",
              "name": "SubGoals"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalActions"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTeams"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalCustomFields"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalUpdateComposerCreate"
            },
            {
              "condition": "includeDraftUpdate",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoalDraftUpdate",
                  "kind": "LinkedField",
                  "name": "latestDraftUpdate",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "GoalDraftUpdateAdapter_draft"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "to": "RESULT"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          },
          {
            "kind": "Variable",
            "name": "capabilitiesContainerId",
            "variableName": "capabilitiesContainerId"
          },
          {
            "kind": "Variable",
            "name": "includeDraftUpdate",
            "variableName": "includeDraftUpdate"
          },
          (v13/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalPanelTabs"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v10/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byId",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  },
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              (v17/*: any*/),
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              (v19/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canAddWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canAddTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              (v20/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canWatchGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedProjects"
              },
              (v21/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddJiraAlignItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveJiraAlignItems"
              }
            ]
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v22/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v8/*: any*/),
                          (v12/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v23/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v23/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v25/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              (v26/*: any*/)
            ]
          },
          (v27/*: any*/),
          (v8/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              (v7/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v7/*: any*/),
                  (v31/*: any*/),
                  (v34/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": (v37/*: any*/)
          },
          (v38/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v39/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v44/*: any*/),
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "targetDate",
            "plural": false,
            "selections": [
              (v47/*: any*/),
              (v48/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v50/*: any*/),
                                  (v28/*: any*/),
                                  (v15/*: any*/),
                                  (v53/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v54/*: any*/),
                          (v55/*: any*/),
                          (v56/*: any*/),
                          (v57/*: any*/),
                          (v58/*: any*/),
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "latestValue",
                            "plural": false,
                            "selections": (v60/*: any*/)
                          },
                          (v26/*: any*/),
                          (v68/*: any*/),
                          (v69/*: any*/)
                        ]
                      },
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/),
                      (v15/*: any*/),
                      (v75/*: any*/)
                    ]
                  }
                ]
              },
              (v26/*: any*/)
            ]
          },
          (v77/*: any*/),
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v77/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v7/*: any*/),
                          (v32/*: any*/)
                        ]
                      },
                      (v39/*: any*/),
                      (v79/*: any*/),
                      (v12/*: any*/),
                      (v80/*: any*/),
                      (v8/*: any*/),
                      (v42/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v21/*: any*/)
                        ]
                      },
                      {
                        "args": (v82/*: any*/),
                        "concreteType": "TownsquareProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v39/*: any*/),
                                  (v8/*: any*/),
                                  (v12/*: any*/),
                                  (v83/*: any*/),
                                  (v84/*: any*/),
                                  (v86/*: any*/),
                                  (v41/*: any*/),
                                  (v15/*: any*/),
                                  (v89/*: any*/)
                                ]
                              },
                              (v64/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          (v67/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      },
                      (v90/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v9/*: any*/),
                          (v40/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": (v85/*: any*/)
                      },
                      (v38/*: any*/)
                    ]
                  }
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "args": (v91/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalProgress",
                        "kind": "LinkedField",
                        "name": "progress",
                        "plural": false,
                        "selections": (v92/*: any*/)
                      },
                      (v56/*: any*/),
                      (v7/*: any*/),
                      (v39/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": (v93/*: any*/)
                      },
                      (v8/*: any*/),
                      (v80/*: any*/),
                      (v27/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v71/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v50/*: any*/),
                                              (v28/*: any*/),
                                              (v53/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v7/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v54/*: any*/),
                                      (v55/*: any*/),
                                      (v8/*: any*/),
                                      (v7/*: any*/),
                                      (v68/*: any*/),
                                      (v69/*: any*/)
                                    ]
                                  },
                                  (v72/*: any*/),
                                  (v70/*: any*/),
                                  (v75/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v9/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v38/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": [
                          (v47/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v17/*: any*/),
                          (v94/*: any*/)
                        ]
                      },
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/)
                    ]
                  },
                  (v15/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              (v94/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v7/*: any*/),
              (v77/*: any*/),
              (v79/*: any*/),
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": (v29/*: any*/)
              },
              (v8/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v32/*: any*/),
                  (v7/*: any*/)
                ]
              },
              (v42/*: any*/),
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v95/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v66/*: any*/),
                  (v65/*: any*/)
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v96/*: any*/),
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v7/*: any*/),
                      (v9/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareSlackConnectionConnection",
            "kind": "LinkedField",
            "name": "slackChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareSlackConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareSlackConnection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareSlackChannel",
                        "kind": "LinkedField",
                        "name": "channel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "numMembers"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
            "kind": "LinkedField",
            "name": "msteamsChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v82/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "args": (v91/*: any*/),
                        "concreteType": "TownsquareTeamConnection",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareTeamEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v24/*: any*/)
                              }
                            ]
                          }
                        ],
                        "storageKey": "teams(first:50)"
                      },
                      (v15/*: any*/),
                      (v84/*: any*/),
                      (v41/*: any*/),
                      (v89/*: any*/),
                      {
                        "concreteType": "TownsquareProjectUpdate",
                        "kind": "LinkedField",
                        "name": "latestUserUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectPhaseDetails",
                            "kind": "LinkedField",
                            "name": "newPhase",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "_id",
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      },
                      (v39/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/),
                      (v83/*: any*/),
                      (v86/*: any*/)
                    ]
                  },
                  (v15/*: any*/),
                  (v64/*: any*/)
                ]
              },
              (v67/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          (v90/*: any*/),
          {
            "concreteType": "TownsquareGoalTeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      }
                    ]
                  }
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v97/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v26/*: any*/)
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v97/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v26/*: any*/)
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v97/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "args": (v98/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isUser"
                                      },
                                      (v8/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v64/*: any*/)
                                ]
                              },
                              (v67/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v98/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v26/*: any*/)
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v95/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canSetMultipleValues"
                                  },
                                  {
                                    "args": (v98/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v28/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "args": (v98/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v15/*: any*/)
                                    ]
                                  },
                                  (v64/*: any*/)
                                ]
                              },
                              (v67/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v98/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v26/*: any*/)
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareConnectedUpdates",
            "kind": "LinkedField",
            "name": "connectedUpdates",
            "plural": false,
            "selections": [
              {
                "args": (v99/*: any*/),
                "concreteType": "TownsquareConnectedUpdateConnection",
                "kind": "LinkedField",
                "name": "successMeasureUpdates",
                "plural": false,
                "selections": (v100/*: any*/),
                "storageKey": "successMeasureUpdates(first:1)"
              },
              {
                "args": (v99/*: any*/),
                "concreteType": "TownsquareConnectedUpdateConnection",
                "kind": "LinkedField",
                "name": "subGoalUpdates",
                "plural": false,
                "selections": (v100/*: any*/),
                "storageKey": "subGoalUpdates(first:1)"
              },
              {
                "args": (v99/*: any*/),
                "concreteType": "TownsquareConnectedUpdateConnection",
                "kind": "LinkedField",
                "name": "projectUpdates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareConnectedUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "sourceProject",
                        "plural": false,
                        "selections": (v24/*: any*/)
                      }
                    ]
                  }
                ],
                "storageKey": "projectUpdates(first:1)"
              }
            ]
          },
          {
            "args": (v101/*: any*/),
            "concreteType": "TownsquareGoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v102/*: any*/),
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v102/*: any*/),
                                  (v95/*: any*/),
                                  (v7/*: any*/),
                                  (v56/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v15/*: any*/),
                      (v44/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasConnectedUpdates"
                      },
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v37/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v102/*: any*/),
                                  (v95/*: any*/),
                                  (v15/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isTownsquareHighlight"
                                  },
                                  (v104/*: any*/),
                                  (v105/*: any*/),
                                  (v44/*: any*/),
                                  (v106/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v26/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v54/*: any*/),
                                      (v55/*: any*/),
                                      (v56/*: any*/),
                                      (v58/*: any*/),
                                      (v78/*: any*/),
                                      {
                                        "args": (v62/*: any*/),
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v107/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v107/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v60/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v56/*: any*/),
                                          (v8/*: any*/),
                                          (v54/*: any*/),
                                          (v55/*: any*/),
                                          (v57/*: any*/),
                                          (v58/*: any*/),
                                          (v78/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v46/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v28/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v7/*: any*/),
                                      (v71/*: any*/),
                                      (v72/*: any*/),
                                      (v70/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v7/*: any*/),
                          (v38/*: any*/),
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                              }
                            ],
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v102/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v102/*: any*/),
                                                  (v95/*: any*/),
                                                  (v7/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          },
                          (v108/*: any*/),
                          (v77/*: any*/),
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": (v109/*: any*/)
                          },
                          {
                            "alias": "successMeasureCount",
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": (v109/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": (v93/*: any*/)
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": (v110/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v111/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v92/*: any*/)
                      },
                      {
                        "args": (v91/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v76/*: any*/)
                                    ]
                                  },
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v40/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v112/*: any*/),
                      {
                        "args": (v98/*: any*/),
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v40/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v24/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v24/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "viewers(first:100)"
                      },
                      (v12/*: any*/),
                      (v113/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v37/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v111/*: any*/)
                      }
                    ]
                  },
                  (v64/*: any*/)
                ]
              },
              (v67/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": "updates(first:20)"
          },
          {
            "args": (v101/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "concreteType": "TownsquareGoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v73/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          },
          (v108/*: any*/),
          (v95/*: any*/),
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          (v113/*: any*/),
          (v56/*: any*/),
          {
            "kind": "ScalarField",
            "name": "updateStreak"
          },
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "isWatching"
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v114/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v114/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v114/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "args": (v115/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "workItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v11/*: any*/),
                          (v102/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v25/*: any*/)
                    ]
                  },
                  (v64/*: any*/),
                  (v7/*: any*/)
                ]
              },
              (v67/*: any*/),
              (v26/*: any*/)
            ]
          },
          {
            "args": (v115/*: any*/),
            "filters": [
              "queryContext"
            ],
            "handle": "connection",
            "key": "GoalContentJira_workItems",
            "kind": "LinkedHandle",
            "name": "workItems"
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectName"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "mercuryProjectStatus",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mercuryName"
                              },
                              (v25/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryTargetDateEnd"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectUrl"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "mercuryProjectOwner",
                            "plural": false,
                            "selections": (v110/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "externalOwner",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "firstName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastName"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAlignAggProject"
                      },
                      (v25/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              (v26/*: any*/)
            ]
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v87/*: any*/)
              }
            ]
          },
          {
            "alias": "learningsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "LEARNING"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v116/*: any*/),
            "storageKey": "highlights(type:\"LEARNING\")"
          },
          {
            "alias": "risksHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "RISK"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v116/*: any*/),
            "storageKey": "highlights(type:\"RISK\")"
          },
          {
            "alias": "decisionsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "DECISION"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v116/*: any*/),
            "storageKey": "highlights(type:\"DECISION\")"
          },
          {
            "condition": "includeDraftUpdate",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalDraftUpdate",
                "kind": "LinkedField",
                "name": "latestDraftUpdate",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goal",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v70/*: any*/),
                                  (v71/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v54/*: any*/),
                                      (v55/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v80/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": [
                          (v48/*: any*/),
                          (v74/*: any*/)
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  (v102/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  (v35/*: any*/),
                  {
                    "concreteType": "TownsquareTargetDateInputDraft",
                    "kind": "LinkedField",
                    "name": "targetDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "date"
                      },
                      (v48/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareMetricUpdateInputDraft",
                    "kind": "LinkedField",
                    "name": "metricUpdate",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "targetId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newValue"
                      },
                      (v59/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareUpdateNoteInputDraft",
                    "kind": "LinkedField",
                    "name": "updateNotes",
                    "plural": true,
                    "selections": [
                      (v102/*: any*/),
                      (v95/*: any*/),
                      (v22/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareUpdateHighlightInputDraft",
                    "kind": "LinkedField",
                    "name": "highlights",
                    "plural": true,
                    "selections": [
                      (v102/*: any*/),
                      (v95/*: any*/),
                      (v54/*: any*/)
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "provenance_extension"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": (v63/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "modifiedDate"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "capabilitiesContainerId"
          }
        ],
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          }
        ]
      },
      (v6/*: any*/)
    ]
  },
  "params": {
    "id": "654b627817353273a312709c32bb47617276efafdc9a468b0def507bcd7e0cae",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "98ed061cdef4c2a478e913441e5fbdde";

export default node;
